import React from 'react';
import { CheckIcon, LockKeyholeIcon } from 'lucide-react';
import { salesPageData, checkoutHref, isPlaceholder } from '../data/salesPageData';
import { CTAButton } from './ui/CTAButton';
const INCLUDES = ['500+ proyectos.', '8 Bonos Especiales.', 'Acceso digital.', 'Acceso ilimitado.', 'Sin mensualidad.', 'Garantía 7 días.'];
const ANCHOR_USES = ['quieras aprender,', 'quieras practicar,', 'quieras fabricar algo para tu casa,', 'aparezca un nuevo trabajo,', 'quieras probar otro estilo,', 'necesites inspiración,', 'no sepas qué fabricar después.'];
export function OfferSection() {
  const hasRegularPrice = !isPlaceholder(salesPageData.regularPrice);
  const hasPaymentMethods = salesPageData.paymentMethods.length > 0;
  return <section id="oferta" className="relative overflow-hidden border-t border-[#D89A3D]/25 bg-[#181512]" aria-labelledby="offer-title" data-id="element-179" data-mp="wchfwqunu0gw">
      <div className="absolute left-1/2 top-0 h-[500px] w-[860px] -translate-x-1/2 rounded-full bg-[#FF7A00]/12 blur-[160px]" aria-hidden="true" data-id="element-180" data-mp="2t7m6u5u62l7d" />

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-181" data-mp="12ojx8faic8nc">
        <h2 id="offer-title" className="title-glow reveal mx-auto max-w-3xl text-center font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#F8F3EA] sm:text-5xl" data-id="element-182" data-mp="xwjsm9jhsrkf">
          Todo lo que <span className="accent-glow text-[#FF7A00]" data-id="element-183" data-mp="owwsrs6evtth">desbloqueás hoy</span>
        </h2>
        <div className="gold-rule mx-auto mt-6 w-48" aria-hidden="true" data-id="element-184" data-mp="1lmw9i9wptyn5" />

        <div className="premium-card mx-auto mt-12 max-w-3xl overflow-hidden rounded-2xl border border-[#D89A3D]/25 bg-[#111111]" data-id="element-185" data-mp="1gn9wa0gw0iec">
          <ul data-id="element-186" data-mp="1ckwqxd61ymi3">
            <li className="flex flex-wrap items-center justify-between gap-2 border-b border-[#EFEDE8]/10 bg-[#3A2416]/25 px-5 py-4 sm:px-7" data-id="element-187" data-mp="1ckd87u8kvu30">
              <div data-id="element-188" data-mp="17oxv54iea27n">
                <p className="font-display text-sm font-extrabold uppercase tracking-tight text-[#F8F3EA]" data-id="element-189" data-mp="169dglu621ww">
                  La Bóveda Principal
                </p>
                <p className="mt-0.5 text-xs text-[#EFEDE8]/60" data-id="element-190" data-mp="3sex4nif38jcd">
                  {salesPageData.mainProduct.description}
                </p>
              </div>
              <p className="font-numeric text-lg font-bold text-[#EFEDE8]/70" data-id="element-191" data-mp="2mn6nhq4lf2h">
                {salesPageData.mainProduct.referenceValue}
              </p>
            </li>

            {salesPageData.bonuses.map(bonus => <li key={bonus.number} className="flex flex-wrap items-center justify-between gap-2 border-b border-[#EFEDE8]/8 px-5 py-3.5 sm:px-7" data-id="element-192" data-mp="3otllmvc39csa">
                <div data-id="element-193" data-mp="3fu8a7x4eme4x">
                  <p className="font-numeric text-[10px] font-bold uppercase tracking-[0.18em] text-[#FF7A00]" data-id="element-194" data-mp="3fuhxve1z897g">
                    Bono #{bonus.number}
                  </p>
                  <p className="text-sm font-semibold text-[#F8F3EA]" data-id="element-195" data-mp="364ez0x86c117">{bonus.name}</p>
                </div>
                <p className="font-numeric text-base font-bold text-[#EFEDE8]/60" data-id="element-196" data-mp="2s4w2z2sn0g59">
                  {bonus.value}
                </p>
              </li>)}
          </ul>

          <div className="px-5 py-6 text-center sm:px-7" data-id="element-197" data-mp="2x5tfayqyufyu">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#EFEDE8]/55" data-id="element-198" data-mp="2dizzb6vt3828">
              Valor individual / referencial de todos los recursos
            </p>
            <p className="mt-1.5 font-numeric text-3xl font-bold text-[#EFEDE8]/55 line-through sm:text-4xl" data-id="element-199" data-mp="2mj4zox2l166w">
              {salesPageData.referenceValue} {salesPageData.currency}
            </p>
            {hasRegularPrice && <p className="mt-2 text-xs text-[#EFEDE8]/50" data-id="element-200" data-mp="2wfrizhf9fp6t">
                Precio regular: {salesPageData.regularPrice} {salesPageData.currency}
              </p>}
          </div>
        </div>

        <p className="reveal mx-auto mt-10 max-w-2xl text-center font-display text-xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-201" data-mp="365kruao0pq7d">
          Pero hoy no necesitás pagar {salesPageData.referenceValue}.
        </p>

        {/* Caja de precio */}
        <div className="reveal mx-auto mt-8 max-w-xl rounded-2xl border-2 border-[#FF7A00]/60 bg-[#111111] p-6 text-center shadow-[inset_0_1px_0_rgba(248,243,234,0.08),0_0_0_1px_rgba(216,154,61,0.3),0_0_60px_-16px_rgba(255,122,0,0.75),0_40px_90px_-45px_rgba(0,0,0,1)] sm:p-10" data-id="element-202" data-mp="3a8ptkb09xnuy">
          <p className="font-display text-sm font-extrabold uppercase tracking-[0.14em] text-[#D89A3D] sm:text-base" data-id="element-203" data-mp="1i8tq2z8s42ia">
            Abrí toda la Bóveda por
          </p>
          <p className="accent-glow mt-3 font-numeric text-6xl font-bold leading-none text-[#FF7A00] sm:text-7xl" data-id="element-204" data-mp="1m9x21anphee8">
            {salesPageData.promotionalPrice}
          </p>
          <p className="mt-2 font-display text-sm font-extrabold uppercase tracking-[0.22em] text-[#F8F3EA]" data-id="element-205" data-mp="ukag8fa2zho3">
            {salesPageData.currency} · Pago único
          </p>

          <ul className="mx-auto mt-7 grid max-w-sm gap-2 text-left" data-id="element-206" data-mp="13kgrduib45k3">
            {INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5 text-sm text-[#EFEDE8]/85" data-id="element-207" data-mp="2a09kvgkhovjl">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#FF7A00]" aria-hidden="true" data-id="element-208" data-mp="2ez45mo20ou6c" />
                {item}
              </li>)}
          </ul>

          <div className="mt-8" data-id="element-209" data-mp="2p2j6x2z9v6no">
            <CTAButton href={checkoutHref()} external size="large" fullWidth data-id="element-210" data-mp="2k3y4cwwjsaw2">
              <LockKeyholeIcon className="h-5 w-5" aria-hidden="true" data-id="element-211" data-mp="2k614i9rezkei" />
              Quiero acceder ahora
            </CTAButton>
            <p className="mt-3 text-xs text-[#EFEDE8]/55" data-id="element-212" data-mp="2bbw6959yb6oy">
              Pago seguro · Acceso digital · Garantía 7 días
            </p>
            {hasPaymentMethods && <ul className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-213" data-mp="26duocno9hdf2">
                {salesPageData.paymentMethods.map(method => <li key={method} className="rounded-md border border-[#EFEDE8]/12 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-[#EFEDE8]/60" data-id="element-214" data-mp="1wedju9kqx5ko">
                    {method}
                  </li>)}
              </ul>}
          </div>
        </div>

        {/* Anclaje de valor */}
        <div className="reveal mx-auto mt-14 max-w-3xl rounded-2xl border border-[#EFEDE8]/10 bg-[#111111] p-7 sm:p-10" data-id="element-215" data-mp="3qq1zyf2pre6n">
          <p className="font-display text-base font-extrabold uppercase tracking-[0.14em] text-[#D89A3D]" data-id="element-216" data-mp="1k3m9vte4p8b6">
            Pensalo así.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-[#EFEDE8]/75 sm:text-base" data-id="element-217" data-mp="1owfgkmt5qqpw">
            No estás comprando un plano. Ni diez. Ni veinte.
          </p>
          <p className="mt-2 text-[15px] font-semibold leading-relaxed text-[#F8F3EA] sm:text-base" data-id="element-218" data-mp="1f49pdfaqcdbr">
            Estás desbloqueando más de 500 proyectos + 8 Bonos complementarios.
          </p>
          <p className="mt-5 text-sm text-[#EFEDE8]/65" data-id="element-219" data-mp="27tyqdsnfwddd">
            Una biblioteca que puede acompañarte cuando:
          </p>
          <ul className="mt-3 grid gap-1.5 sm:grid-cols-2" data-id="element-220" data-mp="1ttfkar2jbhdu">
            {ANCHOR_USES.map(use => <li key={use} className="flex items-start gap-2 text-sm text-[#EFEDE8]/80" data-id="element-221" data-mp="1yrza52k91dbh">
                <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#FF7A00]" data-id="element-222" data-mp="ieiql3veo405" />
                {use}
              </li>)}
          </ul>
          <p className="mt-8 border-t border-[#EFEDE8]/10 pt-7 text-center font-display text-xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-223" data-mp="nbsgekmpihoi">
            No compres un proyecto.
            <span className="block text-[#FF7A00]" data-id="element-224" data-mp="axm29wnyevsd">Desbloqueá una Bóveda entera.</span>
          </p>
        </div>
      </div>
    </section>;
}